import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function decodeHtmlEntities(text: string): string {
  return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&nbsp;/g, ' ')
}

/** Strip HTML tags and decode common entities, returning the first line of plain text. */
export function stripHtml(html: string | undefined | null): string {
  if (!html) return ''
  const text = decodeHtmlEntities(html.replace(/<[^>]*>/g, '\n'))
  const firstLine = text.split(/\n/).map(l => l.trim()).filter(Boolean)[0]
  return firstLine ?? ''
}

/** Strip HTML tags and decode entities, keeping paragraph breaks — the full text, not a summary. */
export function htmlToPlainText(html: string | undefined | null): string {
  if (!html) return ''
  const text = decodeHtmlEntities(html.replace(/<\/(p|div|h[1-6]|li)>/gi, '\n').replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, ''))
  return text.split(/\n/).map(l => l.trim()).filter(Boolean).join('\n\n')
}
